<template>
  <div class="content">
    <div class="container">
      <div class="modular-title">
        <div class="title-left">
          <!-- <div class="title-line"></div> -->
          <div>{{ data.title }}</div>
        </div>
      </div>
      <div class="user-msg flex_b">
        <div class="flex_c" @click="gotoUserpage">
          <div class="user-img">
            <van-image
              round
              fit="cover"
              width="100%"
              height="100%"
              :src="data.user ? data.user.avatar : ''"
              alt=""
            />
          </div>
          <div>
            <div class="name">{{ data.user ? data.user.nickname : "" }}</div>
            <div class="timer">{{ data.time }}</div>
          </div>
        </div>
        <template v-if="data.isFollow != -1">
          <div class="focus" v-if="data.isFollow == 0" @click.stop="follow">
            <i class="iconfont icon-jia"></i>关注
          </div>
          <div
            class="focus isfocus"
            v-if="data.isFollow == 1"
            @click.stop="follow"
          >
            <i class="iconfont icon-check"></i>已关注
          </div>
        </template>
      </div>
      <div v-html="getnode(data.content)"></div>
    </div>
    <div class="container1" v-if="tType != 0" @click="goto">
      <div style="display:flex;align-items: center;" class="teacher-user">
        <div class="user-img">
          <van-image
            round
            fit="cover"
            width="100%"
            height="100%"
            :src="data.teacher ? data.teacher.avatar : ''"
            alt=""
          />
        </div>
        <div class="user-right">
          <div class="name">
            {{ data.teacher ? data.teacher.nickname : "" }}
          </div>
          <div class="font" v-if="data.teacher.introduction">
            {{ data.teacher ? data.teacher.introduction : "" }}
          </div>
        </div>
      </div>

      <div class="c-content">
        <div class="flex_b flex_b">
          <div class="s-box flex_c">
            <img class="i-1" src="@/assets/pl.png" alt="" srcset="" />
            {{ data.teacher ? data.teacher.answer : "" }}解答
          </div>
          <div class="s-box flex_c">
            <img class="i-2" src="@/assets/h.png" alt="" srcset="" />
            {{ data.teacher ? data.teacher.evaluate : "" }}评价
          </div>
          <div class="s-box flex_c">
            <i class="iconfont icon-guanzhu"></i>
            {{ data.teacher ? data.teacher.fansAllNum : "" }}粉丝
          </div>
        </div>
      </div>
    </div>
    <div class="commment">
      <div class="title">评论{{ data.commentNum }}</div>
      <div class="c-content">
        <div class="pl">
          <div class="inp-box">
            <input
              type="text"
              ref="inp"
              v-model="sendText"
              placeholder="我也来说几句~"
            />
          </div>
          <div
            class="send"
            v-show="sendText"
            @mousedown.prevent
            @click.stop="communityComment"
          >
            发送
          </div>
        </div>
      </div>

      <div class="comment-list">
        <div class="cl-item" v-for="(item, index) in arlist" :key="index">
          <div class="user-img">
            <van-image
              round
              fit="cover"
              width="100%"
              height="100%"
              :src="item.thumb"
              alt=""
            />
          </div>
          <div
            class="cl-content"
            :class="index == arlist.length - 1 ? 'border-n' : ''"
          >
            <div class="flex_b">
              <div class="user-box">
                <div class="name">{{ item.user }}</div>
                <div class="timer">{{ item.time }}</div>
              </div>
              <div
                @click="fabulous(item)"
                class="flex_c c-num"
                :class="item.isFabulous == 1 ? 'red' : ''"
              >
                <i class="iconfont icon-zan"></i>{{ item.fabulousNum }}
              </div>
            </div>
            <div class="c-c">
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="c-more" v-if="data.commentNum > 3" @click="gotoPage">
          查看全部评论({{ data.commentNum }})>>
        </div>
      </div>
    </div>
    <div class="like">
      <div class="title">— 猜你喜欢 —</div>
      <div class="like-c" :class="share == 1 ? 'p40' : ''">
        <div
          class="like-c-item flex_b"
          v-for="(item, index) in data.ArticleList"
          :key="index"
          @click="serPage(item)"
        >
          <div class="img">
            <van-image
              fit="cover"
              width="100%"
              height="100%"
              :src="item.thumb"
              alt=""
            />
          </div>
          <div class="l-c">
            <div class="font">{{ item.title }}</div>
            <div class="flex_b">
              <div class="flex_c">
                <div class="user-img">
                  <van-image
                    round
                    fit="cover"
                    width="100%"
                    height="100%"
                    :src="item.avatar"
                    alt=""
                  />
                </div>
                <div>{{ item.author }}</div>
              </div>
              <div>
                <i class="iconfont icon-yanjing"></i>{{ item.read }}人看过
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="back" v-if="share == 1">
      <div @click="back" >返回首页</div>
      <div @click="popShow = true">关注公众号</div>
    </div>
    <div class="mask" v-if="popShow">
      <img src="@/assets/ewm.png" class="ewm" alt="" srcset="">
      <img src="@/assets/close.png" @click="popShow = false" class="close" alt="" srcset="">
    </div>
  </div>
</template>

<script>
/**
@description:文章详情
@createTime:2021-09-17
@create:wq
*/
import { formatRichText } from "../../../utils/tool";
import { HERF, getQueryString } from "@/utils/tool";
import wx from "jweixin-module";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      id: "",
      data: "",
      cflag: true,
      sendText: "",
      arlist: [],
      tType: 0,
      share:0,
      popShow:false,
      thumb:''
    };
  },
  computed: {
    getnode() {
      return function(html) {
        return formatRichText(html);
      };
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.id ? this.$route.query.id: getQueryString("id");
    this.getdata(1);

    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
  },
  methods: {
    serPage(item) {
      this.id = item.id;
      this.getdata();
      // this.$router.push({
      //   path: "wzdetails",
      //   query: { id: item.id },
      // });
      // this.id = this.$route.query.id;
      // this.getdata();
    },
    gotoPage() {
      this.$router.push({
        path: "wzcdetails",
        query: { id: this.id },
      });
    },
    gotoUserpage() {
      if (this.data.isFollow == -1 || this.data.isTeacher != 1) {
        return;
      }

      this.$router.push({
        path: "teacherDetails",
        query: { id: this.data.user.id },
      });
    },
    follow() {
      this.api.follow({ id: this.data.user.id }).then(() => {
        if (this.data.isFollow == 1) {
          this.data.isFollow = 0;
          this.Toast.success("取消成功");
        } else {
          this.data.isFollow = 1;
          this.Toast.success("关注成功");
        }
      });
    },
    goto() {
      this.$router.push({
        path: "teacherDetails",
        query: { id: this.data.teacher.id },
      });
    },
    getdata(t) {
      // console.log(this.id,'---------id------------')
      this.api.articleDetails({ id: this.id }).then((res) => {
        this.data = res.data;
        this.tType = res.data.teacher.type;
        this.arlist = res.data.commentList;
        this.thumb = res.data.thumb;
        if (t == 1) {
          this.jsSdk();
        }
      });
    },
    fabulous(item) {
      this.api.articleCommentFabulous({ id: item.id }).then((res) => {
        if (item.isFabulous == 0) {
          item.isFabulous = 1;
          item.fabulousNum = Number(item.fabulousNum) + 1;
        } else {
          item.isFabulous = 0;
          item.fabulousNum = Number(item.fabulousNum) - 1;
        }
      });
    },
    back(){
      window.location.href = HERF + '/h5/#/'
    },
    //评论
    communityComment() {
      if (!this.cflag) return;

      this.cflag = false;
      this.api
        .articleComment({
          id: this.id,
          text: this.sendText,
        })
        .then(() => {
          this.getdata();
          // const tz = this.list.find((o) => o.id == this.postsID);
          // const newobj = {
          //   title: this.sendText,
          //   name: JSON.parse(localStorage.getItem("user")).name,
          //   cid: this.postsID,
          //   pid: this.pid,
          //   pName: this.pName,
          //   uid: JSON.parse(localStorage.getItem("user")).id,
          // };
          // tz.commentList.push(newobj);
          this.showInput = false;
          this.sendText = "";
          this.cflag = true;
        });
    },
    jsSdk() {
      const u = navigator.userAgent;
      let that = this;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
        // url = window.location.href;
      } else {
        url = window.location.href;
      }

      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });
        let user = localStorage.getItem("user");
        if (user) {
          user = JSON.parse(user);
        } else {
          user = "";
        }

        let u = "#" + window.location.href.split("#")[1];
        u = HERF + "/h5/#/wzdetails?id="+ that.id+"&share=1";

        console.log(u, "-----------shareurl----------");
        let des = that.data.title ? that.data.title : "";
        // console.log(des, "---------");
        wx.ready(function() {
          var title = "可以测";
          // var myurl = url;
          // var myurl = 'http://keyiche.anagelink.cn/h5';
          // var imgUrl = HERF + "/backstage/kycx.png";
          var imgUrl = that.thumb
          //分享给朋友
          wx.updateAppMessageShareData({
            title: des, // 分享标题
            desc: '优质推荐 您的好友强烈推荐您查看，点击查看。', // 分享描述
            link: u, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
          wx.updateTimelineShareData({
            title: des, // 分享标题
            desc: '优质推荐 您的好友强烈推荐您查看，点击查看。', // 分享描述
            link: u, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });

          wx.error((res) => {
            console.log(res);
          });
          // TODO
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: #f1f1f1;
}
.container {
  background: #fff;
  padding: 0.4rem 0.24rem;
  // padding-bottom: 0;
}
.flex_b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_c {
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-msg {
  display: flex;
  margin-bottom: 0.3rem;
  align-items: center;
  .user-img {
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.32rem;
  }
  .name {
    font-size: 0.32rem;
    color: #4cd8d4;
    line-height: 1;
    margin-bottom: 0.13rem;
  }
  .timer {
    color: #999;
    font-size: 0.25rem;
    line-height: 1;
  }
  .focus {
    width: 1.3rem;
    height: 0.6rem;
    background: rgba(79, 217, 213, 0.1);
    border: 1px solid #4fd9d5;
    border-radius: 0.3rem;
    font-size: 0.26rem;
    font-weight: 400;
    color: #4fd9d5;
    display: flex;
    align-items: center;
    justify-content: center;
    &.isfocus {
      width: 1.54rem;
      height: 0.6rem;
      background: rgba(188, 188, 188, 0.1);
      border: 1px solid #cccccc;
      border-radius: 0.3rem;
      font-size: 0.26rem;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.modular-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;

  .title-left {
    font-size: 0.4rem;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    .title-line {
      width: 4px;
      height: 16px;
      background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
      opacity: 1;
      border-radius: 0px 4px 4px 0px;
      margin-right: 6px;
    }
  }

  .look-more {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    span {
      margin-right: 6px;
    }
    i {
      font-size: 0.2rem;
    }
  }
}
.container1 {
  margin-top: 0.15rem;
  background: #fff;
  padding-top: 0.37rem;
  .teacher-user {
    padding: 0 0.24rem;
  }
  .user-img {
    // margin: 0 auto;
    width: 1.2rem;
    height: 1.2rem;
    // margin-bottom: 0.23rem;
  }
  .user-right {
    margin-left: 0.3rem;
    flex: 1;
  }
  .font {
    // margin-bottom: 0.54rem;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #666;
  }
  .name {
    // text-align: center;
    margin-bottom: 0.22rem;
    font-size: 0.32rem;
    color: #333;
    font-weight: bold;
  }
  .c-content {
    padding: 0 0.25rem;
    padding-bottom: 0.37rem;
    margin-top: 0.5rem;
    .s-box {
      img {
        &.i-1 {
          width: 0.33rem;
          height: 0.28rem;
        }
        &.i-2 {
          width: 0.25rem;
          height: 0.29rem;
        }
        line-height: 1;
        margin-right: 0.1rem;
      }
      i {
        font-size: 0.28rem;
        color: #999999;
        margin-right: 0.1rem;
      }
      color: #999;
      font-size: 0.28rem;
    }
  }
}
.commment {
  margin-top: 0.15rem;
  background: #fff;
  .title {
    height: 0.94rem;
    line-height: 0.94rem;
    padding-left: 0.24rem;
    color: #333;
    font-size: 0.32rem;
    font-weight: bold;
    border-bottom: 1px solid #e3e3e3;
    // margin-bottom: 0.32rem;
  }
  .c-content {
    padding: 0.32rem 0.24rem;
    .pl {
      height: 0.78rem;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .inp-box {
        background: #f1f1f1;
        border-radius: 0.39rem;
        height: 100%;
        overflow: hidden;
        flex: 1;
        input {
          height: 100%;
          width: 100%;
          font-size: 0.3rem;
          background: #f1f1f1;
          border: 0;
          padding: 0.25rem 0.38rem;
          box-sizing: border-box;
          &::placeholder {
            color: #ccc;
          }
        }
      }

      .send {
        margin-left: 10px;
        background: #4fd9d5;
        font-size: 16px;
        height: 30px;
        color: #ffffff;
        border-radius: 5px;
        line-height: 30px;
        padding: 0 10px;
      }
    }
  }
  .comment-list {
    margin-top: 0.16rem;
    padding: 0 0.24rem;
    .c-more {
      margin-top: 0.32rem;
      font-size: 0.3rem;
      color: #72e0dd;
      text-align: center;
      padding-bottom: 0.3rem;
    }
    .cl-item {
      padding-bottom: 0.32rem;
      display: flex;
      .user-img {
        width: 0.7rem;
        height: 0.7rem;
        margin-right: 0.3rem;
      }

      .cl-content {
        flex: 1;
        border-bottom: 1px solid #e3e3e3;
        &.border-n {
          border-bottom: 0;
          .c-c {
            padding-bottom: 0;
          }
        }
        .user-box {
          height: 0.7rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .name {
          font-size: 0.28rem;
          color: #333;
          font-weight: bold;
          line-height: 1;
          // margin-bottom: 0.18rem;
        }
        .timer {
          font-size: 0.24rem;
          color: #999;
          line-height: 1;
        }
        .c-num {
          font-size: 0.26rem;
          color: #999;
          &.red {
            i {
              color: #72e0dd;
            }
          }
          line-height: 1;
          align-items: flex-end;
          i {
            color: #999;
            margin-right: 0.16rem;
          }
        }
        .c-c {
          color: #333;
          font-size: 0.28rem;
          margin-top: 0.28rem;
          padding-bottom: 0.28rem;
        }
      }
    }
  }
}
.like {
  .title {
    text-align: center;
    height: 1rem;
    line-height: 1rem;
    color: #666;
    font-size: 0.3rem;
  }
  .like-c {
    background: #fff;
    padding: 0 0.4rem;
    .like-c-item {
      padding: 0.4rem 0;
      .img {
        width: 2.4rem;
        overflow: hidden;
        height: 1.6rem;
        border-radius: 0.1rem;
        margin-right: 0.32rem;
      }
      .l-c {
        flex: 1;
        color: #ccc;
        font-size: 0.27rem;
        .font {
          font-size: 0.3rem;
          color: #666;
          font-weight: bold;
          margin-bottom: 0.4rem;
        }
        .user-img {
          width: 0.4rem;
          height: 0.4rem;
          margin-right: 0.13rem;
          overflow: hidden;
        }
        i {
          color: #ccc;
          font-size: 0.27rem;
          margin-right: 0.13rem;
        }
      }
    }
  }
}
.back{
  position: fixed;
  bottom: 0;
  left: 0;
  background: #4cd8d4;
  color: #fff;
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  z-index: 66;
  display: flex;
  div{
    width: 50%;
    &:first-child{
      border-right: 1px solid #fff;
      box-sizing: border-box;
    }
  }
}
.p40{
  padding-bottom: 50px !important;
}
.mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0,0,0,0.35);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .ewm{
    width: 80%;
  }
  .close{
    margin-top: 0.4rem;
    height: 0.8rem;
    width: 0.8rem;
  }
}
</style>
